import React from 'react';
import { shape, string } from 'prop-types';
import styled from 'styled-components';
import { getImage } from 'gatsby-plugin-image';

const AuthorCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    background-color: ${({ theme }) => theme.colorSystem.UIElements[5]};
    border: 2px solid ${({ theme }) => theme.colorSystem.UIElements[6]};
    border-radius: 8px;
    padding: 24px;
    margin: 32px 0 48px 0;
`;

const AuthorPhoto = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;

    @media (min-width: 769px) {
        width: 80px;
        height: 80px;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const AuthorContent = styled.div`
    flex: 1;
`;

const AuthorName = styled.h1`
    font-weight: 700;
    font-size: 1.75rem;
    color: ${({ theme }) => theme.colorSystem.primary[1]};
    margin: 0 0 4px 0;

    @media (min-width: 769px) {
        font-size: 2rem;
    }

    span {
        color: ${({ theme }) => theme.colorSystem.secondary[3]};
    }
`;

const JobTitle = styled.p`
    font-weight: 700;
    color: ${({ theme }) => theme.colorSystem.primary[1]};
    margin: 0 0 16px 0;
`;

const Bio = styled.div`
    color: ${({ theme }) => theme.colorSystem.primary[1]};

    p {
        margin: 0 0 16px 0;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

const AuthorBio = ({ author }) => {
    if (!author) {
        return null;
    }

    return (
        <AuthorCard>
            <AuthorPhoto>
                <img
                    src={getImage(author.photo)?.images?.fallback?.src}
                    alt={author.name}
                />
            </AuthorPhoto>
            <AuthorContent>
                <AuthorName>
                    {author.name}
                    <span>.</span>
                </AuthorName>
                <JobTitle>{author.jobTitle}</JobTitle>
                <Bio
                    dangerouslySetInnerHTML={{
                        __html: (
                            author.longBio ||
                            `${author.jobTitle} with expertise in financial planning and budgeting.`
                        )
                            .replace(/\n\n/g, '</p><p>')
                            .replace(/^(.*)$/, '<p>$1</p>')
                    }}
                />
            </AuthorContent>
        </AuthorCard>
    );
};

AuthorBio.propTypes = {
    author: shape({
        name: string.isRequired,
        jobTitle: string.isRequired,
        longBio: string,
        photo: shape({})
    })
};

export default AuthorBio;
